import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./About.css";

function About() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);

  return (
    <div className="about-wrapper">

      <section className="about-hero">
        <div className="container hero-grid">

          <div className="hero-content">
            <div className="reveal-tag">
              <span className="dot-pulse"></span>
              <span className="tag-text">ESTABLISHED 2026 // PREMIUM POST-LAB</span>
            </div>

            <h1 className="big-title">
              We Craft High-End <br />
              <span className="gradient-text">Architectural Media</span>
            </h1>

            <p className="hero-sub">
              Zero Pix Creative is an elite post-production workspace specializing in real estate photo/video editing and luxury visual enhancement. We bridge the structural gap between raw spatial reality and digital absolute perfection.
            </p>
          </div>

          <div className="hero-visual">
            <div className="premium-glass-card">
              <div className="grid-overlay-mesh"></div>

              <div className="card-top-header">
                <span className="terminal-dot red-d"></span>
                <span className="terminal-dot yellow-d"></span>
                <span className="terminal-dot green-d"></span>
                <span className="spec-label">SYSTEM_METRICS // RE-RENDER</span>
              </div>

              <div className="glass-inner">
                <div className="stat-row">
                  <div className="stat-block">
                    <div className="stat-num-wrapper">
                      <span className="stat-num">99</span>
                      <span className="stat-percent">%</span>
                    </div>
                    <span className="stat-label">CHROMA ACCURACY</span>
                  </div>

                  <div className="stat-divider"></div>

                  <div className="stat-block">
                    <div className="stat-num-wrapper">
                      <span className="stat-num">24</span>
                      <span className="stat-hours">H</span>
                    </div>
                    <span className="stat-label">FAST DELIVERY</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      <section className="about-core">
        <div className="container grid-2">

          <div className="info-card-elite">
            <span className="mini-badge">01 // IDENTITY</span>
            <h2 className="section-label">WHO WE ARE</h2>
            <p className="core-text">
              Our studio architecture combines meticulous surgical precision with high-concept creative design. We formulate ultra-clean, studio-grade visuals that exhibit property profiles under premium light distributions. We enhance your real estate presence dynamically.
            </p>
          </div>

          <div className="info-card-elite">
            <span className="mini-badge">02 // CAPABILITIES</span>
            <h2 className="section-label">WHAT WE DO</h2>

            <ul className="action-list-elite">
              <li>Real Estate Photo Editing (HDR Processing)</li>
              <li>Premium Video Editing (Cinematic Walkthroughs)</li>
              <li>Architectural Media Capture & Direction</li>
              <li>Graphic Architecture & High-End Motion Systems</li>
            </ul>
          </div>

        </div>
      </section>

      <section className="why-section">
        <div className="container">

          <div className="section-header-centered">
            <span className="section-subtitle">STRATEGIC VALUE PROPOSITION</span>
            <h2 className="section-title">Why Outsource To Us</h2>
          </div> <br></br>

          <div className="why-grid-elite">

            <div className="why-card-elite">
              <h4>Expert Visuals</h4>
              <p>Ordinary standard property frames are converted dynamically into attention-grabbing asset listings that lock user interaction metrics immediately.</p>
            </div>

            <div className="why-card-elite">
              <h4>Fast Delivery</h4>
              <p>Acquire heavily balanced digital image configurations with speed, facilitating rapid database listing uploads to outpace standard markets.</p>
            </div>

            <div className="why-card-elite">
              <h4>Consistent Quality</h4>
              <p>Maintained adjustments across entire spectrum groups, assuring consistent luminescent levels through every portfolio listing layer.</p>
            </div>

            <div className="why-card-elite">
              <h4>Cost Effective</h4>
              <p>Bypass heavy in-house workspace setup expenditures and processing utility maintenance while securing elite agency output packages.</p>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}

export default About;